import React, { useEffect, useState } from 'react';
import { redirect, useNavigate, useParams } from "react-router-dom";

import { fetchGame } from '../../services/ledgerService'
import Col from "react-bootstrap/Col";
import { AddPlayerModal } from "./AddPlayerModal";
import { AddTransactionModal } from "./AddTransactionModal";
import { GameHeader } from "./components/GameHeader";
import { GameTotals } from "./components/GameTotals";
import { PlayerSearch } from "./components/PlayerSearch";
import { PlayerStats } from "./components/PlayerStats";
import { useHouseDispatch, useHouseState } from '../../contexts/HouseContext';

import 'react-bootstrap-typeahead/css/Typeahead.css';
import './Ledger.css';

export function GameLedger() {
    const navigate = useNavigate();
    const { loadGame } = useHouseDispatch();
    const { games } = useHouseState();
    const { gameId } = useParams();

    useEffect(() => {
        const fetchGameData = async () => {
            try {
                await loadGame(gameId);
            } catch (e) {
                navigate("/games");
            }
        };

        fetchGameData();
    }, [gameId]);

    if (!games[gameId]) {
        return <div>Loading Game Details...</div>
    }

    return <Ledger game={games[gameId]} />
}

const Ledger = ({ game }) => {
    const { sortPlayers } = useHouseDispatch();

    // add player modal controls
    const [showAddPlayer, setShowAddPlayer] = useState(false)
    const handleCloseAddPlayer  = () => (setShowAddPlayer(false))
    const handleShowAddPlayer  = () => (setShowAddPlayer(true))

    // add transaction modal controls
    const [showAddTransaction, setShowAddTransaction] = useState(false)
    const handleCloseAddTransaction = () => setShowAddTransaction(false)
    const handleShowAddTransaction = () => setShowAddTransaction(true)

    const [activePlayerId, setActivePlayerId] = useState(null);

    // Typeahead
    const [typeaheadInput, setTypeaheadInput] = useState("")
    const [sort, updateSort] = useState({ sortBy: null, sortOrder: null })

    const viewablePlayers = game.players.filter(p =>
        p.name.toLowerCase().indexOf(typeaheadInput.toLowerCase()) > -1
    )

    const onSort = (sortBy) => {
        let sortOrder;
        let confirmedSortBy = sortBy;

        if (sort.sortBy === null || sortBy !== sort.sortBy) {
            sortOrder = 'desc';
        } else if (sortBy === sort.sortBy && sort.sortOrder !== 'asc') {
            sortOrder = 'asc';
        } else {
            confirmedSortBy = null;
            sortOrder = null;
        }
        updateSort({ sortBy: confirmedSortBy, sortOrder: sortOrder });
        sortPlayers(game.id, confirmedSortBy, sortOrder)
    }

    return (
        <>
            <GameHeader game={game} onClick={handleShowAddPlayer} />
            <Col sm={10} className={'mx-auto'}>
                <GameTotals game={game} sort={sort} onSort={onSort} />
                <PlayerSearch
                    value={typeaheadInput}
                    typeaheadResults={viewablePlayers}
                    setTypeaheadInput={setTypeaheadInput}
                />
                <div className="player-stats">
                    {viewablePlayers.map(p => <PlayerStats
                        key={p.id}
                        gameId={game.id}
                        player={p}
                        handleShowAddTransaction={() => {
                            setActivePlayerId(p.id)
                            handleShowAddTransaction()
                        }}
                    />)}
                </div>
            </Col>
            <AddPlayerModal
                gameId={game.id}
                players={game.players}
                show={showAddPlayer}
                handleClose={handleCloseAddPlayer}
            />
            <AddTransactionModal
                game={game}
                player={game.players.find(p => p.id === activePlayerId)}
                show={showAddTransaction}
                handleClose={handleCloseAddTransaction}
            />
        </>
    );
}

export async function loader({ params }) {
    let game = null
    try {
        game = await fetchGame({gameId: params.gameId})
    } catch (e) {
        console.error('Error fetching house data:', e);
        return redirect("/login")
    }

    if (!game) {
        return redirect("/games");
    }

    return { game }
}

